import Vue from 'vue'
import 'emoji-picker-element'

Vue.config.ignoredElements = ['emoji-picker']